import { render } from "./SquareRoot.vue?vue&type=template&id=06758ae4"
import script from "./SquareRoot.vue?vue&type=script&lang=js"
export * from "./SquareRoot.vue?vue&type=script&lang=js"

import "./SquareRoot.vue?vue&type=style&index=0&id=06758ae4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__